<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import PageHeader from "@/components/page-header";
import ExportProgress from "@/components/grid/ExportProgress";
// grid imports
import ImageCell from "@/components/sharedCells/ImageCell";
import { reportHistoryColumns } from "@/utils/dataSource";
import { exportExel } from "@/utils/mixins/exportMixin";
import { deletedUserMixin } from "@/utils/mixins/deletedUserMixin";
import LocationCell from "@/components/dashboard/LocationCell";
import Locations from "@/components/dashboard/Locations";
import CompliancesCell from "@/components/dashboard/CompliancesCell";
import Compliances from "@/components/dashboard/Compliances";
import store from "@/state/store";
import VaccineDetails from "@/components/users/VaccineDetails";
import CustomStore from "devextreme/data/custom_store";
import Api from "../../../services/Api";
import { default as Button } from "devextreme-vue/button";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import AlertFoundActiveSession from "@/components/emergency/AlertFoundActiveSession";
import smileysJson from "@/router/views/customFields/smileys.json";

import DxDataGrid, {
  // DxColumn,
  // DxLookup,
  DxFilterRow,
  DxHeaderFilter,
  DxColumnChooser,
  DxExport,
  DxStateStoring,
  DxPaging,
  DxPager,
  DxToolbar,
  DxItem,
  DxScrolling,
} from "devextreme-vue/data-grid";
import "jspdf-autotable";
import { rfidFormatterMixin } from "@/utils/mixins/rfidFormatterMixin";

const dataGridRef = "dataGrid";

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

export default {
  title: "History",
  name: "History",
  mixins: [exportExel, deletedUserMixin, rfidFormatterMixin],
  components: {
    PageHeader,
    ExportProgress,
    ImageCell,
    LocationCell,
    Locations,
    Compliances,
    CompliancesCell,
    VaccineDetails,
    DxDataGrid,
    // DxColumn,
    // DxLookup,
    DxFilterRow,
    DxHeaderFilter,
    DxColumnChooser,
    DxExport,
    DxStateStoring,
    DxPaging,
    DxPager,
    DxToolbar,
    DxItem,
    Button,
    DxDropDownButton,
    AlertFoundActiveSession,
    DxScrolling,
  },
  data() {
    return {
      historyData : [],
      gridEmptyMessage : this.$t('common.grid.loadingData'),
      allLabels: [],
      getVaccinePCRColumnAppearance: null,
      getCompliances: [],
      allFilterHeaders: [
        "Action",
        "By",
        "Device",
        "UserType",
        "JourneyStage",
        "Site",
        "Area",
        "Input",
        "hasAMask",
        "VaccineDocument",
      ],
      title: "History",
      loaded: false,
      selectedTempreture: "c",
      multipleFilters: [],
      isExport: false,
      options: [
        { text: `°${this.$t("common.temperatureUnits.f")}`, value: "f" },
        { text: `°${this.$t("common.temperatureUnits.c")}`, value: "c" },
      ],
      items: [
        {
          text: "Users",
          href: "/users",
        },
        {
          text: "List",
          active: true,
        },
      ],
      reportHistoryColumns: reportHistoryColumns,
      isServerSideExport: false,
      hasMaskOptions: ["Not Applicable", "Yes", "No"],
      updatedInputTypes: [],
      vaccineOptions: [
        "Vaccinated",
        "Not Applicable",
        "Negative PCR",
        "Unchecked",
      ],
      dataGridRef,
      vaccineDocument: false,
      statusHeaderFilter: [],
      userTypeHeaderFilter: [],
      inputTypeHeaderFilter: [],
      deviceHeaderFilter: [],
      areaHeaderFilter: [],
      siteHeaderFilter: [],
      finalFilterObject: {},
      sortObject: {},
      totalCount: "",
      showClearAll: false,
      dataStore: [],
      allowedOperations: ["contains"],
      selectedOperation: "contains", // default icon
      buttonData: ["Excel", "CSV"],
      dataGridRefName: "History",
      filterValue: [
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 6
        ),
        new Date(),
      ],
      hasMaskHeaderFilter: [
        {
          text: this.$t('common.yes'),
          value: 1,
        },
        {
          text: this.$t('common.no'),
          value: 0,
        },
        {
          text: "-",
          value: -1,
        },
      ],
      vaccineHeaderFilter: [
        {
          text: this.$t('dashboard.grid.vaccineOptions.vaccinated'),
          value: "Vaccinated",
        },
        {
          text: this.$t('dashboard.grid.vaccineOptions.notApplicable'),
          value: "Not Applicable",
        },
        {
          text: this.$t('dashboard.grid.vaccineOptions.negativePcr'),
          value: "Negative PCR",
        },
        {
          text: this.$t('dashboard.grid.vaccineOptions.positivePcr'),
          value: "Positive PCR",
        },
        {
          text: this.$t('dashboard.grid.vaccineOptions.unchecked'),
          value: "Unchecked",
        },
        {
          text: this.$t('dashboard.grid.vaccineOptions.expired'),
          value: "Expired",
        },
        {
          text: this.$t('dashboard.grid.vaccineOptions.notSupported'),
          value: "Not Supported",
        },
      ],
      actionByHeaderFilter: [
        {
          text: this.$t('common.admin'),
          value: "Admin",
        },
        {
          text: this.$t('common.user'),
          value: "User",
        },
        {
          text: this.$t('common.system'),
          value: "System",
        },
        {
          text: this.$t('common.mobileApp'),
          value: "Mobile",
        },
        {
          text: "Wonde",
          value: "Wonde",
        },
      ],
      tempHeaderFilter: [
        {
          name: "<= 30",
          id: [0, 30],
        },
        {
          name: "30 - 34",
          id: [30, 34],
        },
        {
          name: "34 - 40",
          id: [34, 40],
        },
        {
          name: ">= 40",
          id: [40, 50],
        },
      ],
      journeyStageHeaderFilter: [
      {
          text: this.$t('dashboard.grid.journeStages.compliancePending'),
          value: "compliance_pending",
        },
        {
          text: this.$t('dashboard.grid.journeStages.complianceFailed'),
          value: "compliance_failed",
        },
        {
          text: this.$t('dashboard.grid.journeStages.readyToSignIn'),
          value: "ready_to_sign_in",
        },
        {
          text: this.$t('dashboard.grid.journeStages.adminApproval'),
          value: "waiting_for_admin_approval",
        },
        {
          text: this.$t('dashboard.grid.journeStages.adminApprovalFailed'),
          value: "waiting_for_admin_approval_compliance_failed",
        },
        {
          text: this.$t('dashboard.grid.journeStages.rejectedByAdmin'),
          value: "rejected_by_admin",
        },
      ],
      toggleHeaderFilter: [
        {
          text: "Yes",
          value: 1,
        },
        {
          text: "No",
          value: 0,
        },
      ],
      allCustomFields: [],
      fields: [
        {
          dataField: "Image",
          width: "110",
          caption: this.$t("common.image"),
          dataType: "string",
          cellTemplate: "image-cell",
          allowFiltering: false,
          allowEditing: false,
          allowSorting: false,
          visible: true,
          allowHeaderFiltering: false,
        },
        {
          dataField: "FirstName",
          caption: this.$t("common.firstName"),
          dataType: "string",
          visible: true,
          allowFiltering: true,
          allowHeaderFiltering: false,
        },
        {
          dataField: "LastName",
          caption: this.$t("common.lastName"),
          dataType: "string",
          visible: true,
          allowFiltering: true,
          allowHeaderFiltering: false,
        },
        {
          dataField: "Action",
          caption: this.$t("common.grid.action"),
          dataType: "string",
          allowExporting: true,
          cellTemplate: "status-cell",
          visible: true,
          allowFiltering: false,
          allowHeaderFiltering: true,
          headerFilterDataSource: "statusHeaderFilter",
        },
        {
          dataField: "By",
          caption: this.$t("common.by"),
          dataType: "string",
          calculateCellValue: this.calculateActionBy,
          allowFiltering: false,
          allowHeaderFiltering: true,
          visible: true,
          headerFilterDataSource: "actionByHeaderFilter",
        },
        {
          dataField: "At",
          caption: this.$t("common.at"),
          dataType: "datetime",
          minWidth: "200",
          format: "dd/MM/yyyy - hh:mm:ss a",
          filterValue: this.filterValue,
          selectedFilterOperation: "between",
          visible: true,
          allowHeaderFiltering: false,
          allowFiltering: true,
          filterOperations: ["between"],
        },
        {
          dataField: "attendanceCode",
          caption: this.$t("common.attendanceCode"),
          width: "400",
          dataType: "string",
          allowFiltering: false,
          cssClass: "attendanceCodeColumn",
          allowHeaderFiltering: false,
          visible:
            this.getVaccinePCRColumnAppearance &&
            this.getVaccinePCRColumnAppearance.scanAttendanceCode,
        },
        {
          dataField: "Reason",
          caption: this.$t("dashboard.grid.reason"),
          dataType: "string",
          allowFiltering: false,
          allowHeaderFiltering: false,
          visible:
            this.getVaccinePCRColumnAppearance &&
            this.getVaccinePCRColumnAppearance.scanReason,
        },
        {
          dataField: "JourneyStage",
          caption: this.$t("dashboard.grid.currentJourneyStage"),
          allowEditing: false,
          visible: true,
          allowFiltering: false,
          allowHeaderFiltering: true,
          headerFilterDataSource: "journeyStageHeaderFilter",
        },
        {
          dataField: "Site",
          caption: this.$t("common.site"),
          dataType: "string",
          visible: true,
          allowFiltering: false,
          allowHeaderFiltering: true,
          headerFilterDataSource: "siteHeaderFilter",
        },
        {
          dataField: "Area",
          caption: this.$t("common.area"),
          dataType: "string",
          visible: true,
          allowFiltering: false,
          allowHeaderFiltering: true,
          headerFilterDataSource: "areaHeaderFilter",
        },
        {
          dataField: "Host",
          caption: this.$t("common.host"),
          dataType: "string",
          allowFiltering: true,
          allowHeaderFiltering: false,
          visible:
            this.getVaccinePCRColumnAppearance &&
            this.getVaccinePCRColumnAppearance.scanHost,
        },
        {
          dataField: "Device",
          caption: this.$t("common.device"),
          dataType: "string",
          cellTemplate: "kiosk-cell",
          visible: true,
          allowFiltering: false,
          allowHeaderFiltering: "true",
          headerFilterDataSource: "deviceHeaderFilter",
        },
        {
          dataField: "UserType",
          caption: this.$t("common.userType"),
          dataType: "string",
          visible: true,
          allowFiltering: false,
          allowHeaderFiltering: true,
          headerFilterDataSource: "userTypeHeaderFilter",
        },
        {
          dataField: "Input",
          caption: this.$t("common.input"),
          dataType: "string",
          allowEditing: false,
          visible: true,
          allowFiltering: false,
          allowHeaderFiltering: true,
          headerFilterDataSource: "inputTypeHeaderFilter",
        },
        {
          dataField: "temperature",
          caption: this.$t("common.temperature"),
          dataType: "string",
          allowEditing: false,
          cellTemplate: "temperature-cell",
          visible: true,
          allowFiltering: true,
          allowHeaderFiltering: false,
          headerFilterDataSource: "tempHeaderFilter",
          valueExpr: "id",
          displayExpr: "name",
        },
        {
          dataField: "hasAMask",
          caption: this.$t("dashboard.grid.wearingAMask"),
          dataType: "string",
          visible: true,
          allowFiltering: false,
          allowHeaderFiltering: true,
          cellTemplate: "mask-cell",
          headerFilterDataSource: "hasMaskHeaderFilter",
        },
        {
          dataField: "Compliances",
          caption: this.$t("common.compliances"),
          dataType: "string",
          cellTemplate: "compliance-cell",
          allowFiltering: false,
          allowExporting: false,
          allowSorting: false,
          visible: true,
          allowSearch: false,
        },
        {
          dataField: "VaccineDocument",
          caption: this.$t("dashboard.grid.vaccineDoc"),
          dataType: "string",
          cellTemplate: "document-cell",
          allowEditing: false,
          allowFiltering: false,
          allowHeaderFiltering: true,
          visible:
            this.getVaccinePCRColumnAppearance &&
            this.getVaccinePCRColumnAppearance.scanDocument,
          headerFilterDataSource: "vaccineHeaderFilter",
        },
        {
          dataField: "Location",
          caption: this.$t("common.geoLocation"),
          cellTemplate: "Location-cell",
          allowFiltering: false,
          visible: true,
          allowSearch: false,
        },
        {
          dataField: "Notes",
          caption: this.$t("common.notes.notes"),
          dataType: "string",
          width: "250",
          allowHeaderFiltering: false,
          visible: true,
          cellTemplate: "visit-notes-cell",
        },
        {
          dataField: "Email",
          caption: this.$t("common.email"),
          dataType: "string",
          allowHeaderFiltering: false,
          visible: "true",
        },
        {
          dataField: "PhoneNumber",
          caption: this.$t("common.phoneNumber"),
          dataType: "string",
          allowHeaderFiltering: false,
          visible: "true",
        },
        {
          dataField: "RFID",
          dataType: "string",
          allowHeaderFiltering: false,
          visible: true,
          allowSorting: false,
          minWidth: "150",
          cellTemplate: "rfid-template",
        },
        {
          dataField: "ID",
          caption: this.$t("common.id"),
          dataType: "string",
          visible: false,
          allowFiltering: true,
          allowHeaderFiltering: false,
          cellTemplate: "id-cell",
        },
        {
          dataField: "Label",
          caption: this.$t("common.label"),
          allowEditing: false,
          allowHeaderFiltering: false,
          allowFiltering: true,
          visibleIndex: 26,
          minWidth: "150",
          visible: true,
          calculateCellValue: this.calculateLabelValue,
        },
      ],
      smileysToShow: [
        ["sad", "happy"],
        ["sad", "poker", "happy"],
        ["sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy", "smile"],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
        ],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "frown",
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
      ],
      rtlEnabled: false,
    };
  },
  watch: {
    getInputTypes(getInputTypes) {
      this.updatedInputTypes = JSON.parse(JSON.stringify(getInputTypes));
      const objIndex = this.updatedInputTypes.findIndex(
        (obj) => obj.name == "face recognition"
      );
      this.updatedInputTypes[objIndex].name = "Facial Recognition";
    },
    getExportProgessAppearance(value) {
      value && this.$bvModal.show("exportingProgress");
    },
  },
  computed: {
    ...mapGetters("dailyLogbook", [ "getInputTypes" ]),
    ...mapGetters("grid", [
      "getTableHeaders",
      "getExportProgessAppearance",
    ]),
    ...mapGetters("authfack", ["currentEntity", "userDetails"]),
    ...mapGetters("emergency", ["getActiveSessionsCount"]),
    ...mapGetters("i18N", ["getLanguage"]),
    userEmail() {
      return this.userDetails && this.userDetails.email;
    },

    dataGrid() {
      return this.$refs[this.dataGridRefName].instance;
    },
    gridColumns() {
      const fields = this.fields.map((field) => {
        let column = {
          dataField: field.dataField,
          caption: field.caption,
          minWidth: field.minWidth,
          dataType: field.dataType,
          selectedFilterOperation: field.selectedFilterOperation,
          format: field.format,
          allowFiltering: field.allowFiltering,
          allowEditing: field.allowEditing,
          showInColumnChooser: field.showInColumnChooser,
          alignment: field.alignment,
          cssClass: field.cssClass,
          allowExporting: field.allowExporting,
          visible:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == field.dataField
            ) &&
            (this.getTableHeaders.columns?.find(
              (item) => item.dataField == field.dataField
            ).visible ||
              this.getTableHeaders.columns?.find(
                (item) => item.dataField == field.dataField
              ).visible == false)
              ? this.getTableHeaders.columns?.find(
                  (item) => item.dataField == field.dataField
                ).visible
              : field.dataField == "ID"
              ? false
              : true,

          filterValue: this.getFilterValue(field),
          filterValues:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ).filterValues,
            filterType:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ).filterType,
          visibleIndex:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ).visibleIndex
              ? this.getTableHeaders &&
                this.getTableHeaders.columns?.find(
                  (item) => item.dataField == field.dataField
                ) &&
                this.getTableHeaders.columns.find(
                  (item) => item.dataField == field.dataField
                ).visibleIndex
              : field.visibleIndex,
          sortOrder:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ).sortOrder,
          sortIndex:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ).sortIndex,
          allowHeaderFiltering: field.allowHeaderFiltering,
          filterOperations: this.allowedOperations,
          allowSorting: field.allowSorting,
          calculateCellValue: field.calculateCellValue,
        };

        if (field.cellTemplate) {
          column.cellTemplate = field.cellTemplate;
        }

        if (field.headerFilterDataSource) {
          column.headerFilter = {
            dataSource: this[field.headerFilterDataSource],
          };
        }
        return column;
      });

      this.allCustomFields.forEach((field) => {
        let obj = {
          dataField: `customFields.${field.id}`,
          caption:
            field.type == "ratingScale" &&
            (field.metadata[0].show_as == "stars" ||
              field.metadata[0].show_as == "labels")
              ? `${field.name} (Out of ${field.metadata[0].scale_count})`
              : field.name,
          allowFiltering:
            !field.type == "ratingScale" ||
            (field.type == "ratingScale" &&
              (field.metadata[0].show_as == "stars" ||
                field.metadata[0].show_as == "labels")),
          showInColumnChooser: true,
          allowExporting: false,
          allowHeaderFiltering:
            field.type == "ratingScale" || field.type == "toggleButton",
          filterOperations: this.allowedOperations,
          allowSorting: false,
          alignment: "left",
          width: "230",
          visible:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ) &&
            (this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ).visible ||
              this.getTableHeaders.columns?.find(
                (item) => item.dataField == `customFields.${field.id}`
              ).visible == false)
              ? this.getTableHeaders.columns?.find(
                  (item) => item.dataField == `customFields.${field.id}`
                ).visible
              : true,

          filterValue:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ).filterValue,

          filterValues:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ).filterValues,
            filterType:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ).filterType,

          visibleIndex:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ).visibleIndex,

          sortOrder:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ).sortOrder,

          sortIndex:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `customFields.${field.id}`
            ).sortIndex,
        };
        // if (field.type === "date") obj.cellTemplate = "date-template";
        if (field.type === "toggleButton") {
          // obj.cellTemplate = "toggle-template";
          obj.headerFilter = {
            dataSource: this.toggleHeaderFilter,
          };
        } else if (field.type === "ratingScale") {
          let ratingHeaderFilter = [];
          if (field.metadata[0].show_as !== "smileys") {
            for (let i = 0; i < field.metadata[0].scale_count; i++) {
              ratingHeaderFilter.push({
                text: (i + 1).toString(),
                value: (i + 1).toString(),
              });
            }
          } else {
            ratingHeaderFilter = [
              { text: "Bad", value: 1 },
              { text: "Poor", value: 2 },
              { text: "OK", value: 3 },
              { text: "Good", value: 4 },
              { text: "Great", value: 5 },
            ];
          }
          obj.headerFilter = {
            dataSource: ratingHeaderFilter,
          };
          //   obj.cellTemplate = `${field.metadata[0].show_as}-template`;
          //   obj.cssClass = field.metadata[0].show_as + field.metadata[0].scale_count;
        }
        // else if (field.type == "checkboxes") {
        //   obj.cellTemplate = "checkboxes-template";
        // } else
        obj.cellTemplate = "customField-template";
        fields.push(obj);
      });

      // console.log("fields", fields);
      return fields;
    },
  },
  methods: {
    ...mapActions("grid", [
      "onTableHeader",
      "createTableHeaders",
      "updateTableHeaders",
      "resetFilterValues",
      "exportJobBE",
    ]),
    ...mapActions("modal", ["onResetModal", "setData"]),
    ...mapActions("dashboard", ["fetchHistoryData"]),

    calculateLabelValue(rowData) {
      const labelArr = [];
      if (rowData.Label && rowData.Label.length) {
        rowData.Label.map((item) => {
          const labelExist = this.allLabels.find(
            (label) => label.id == item.mapping_value
          );
          if (labelExist) labelArr.push(labelExist.name);
        });
      }
      return labelArr.length ? labelArr.join(" - ") : "-";
    },

    getRowTemp(row) {
      if (this.selectedTempreture == "c") {
        if (row.temperature >= 30 && row.temperature <= 45)
          return row.temperature;
        const degree = row.temperature;
        const deg = (degree - 32) * (5 / 9);
        const tempInC = Math.round(deg * 10) / 10;
        return tempInC;
      } else {
        if (row.temperature >= 86 && row.temperature <= 113)
          return row.temperature;
        const degree = row.temperature * (9 / 5) + 32;
        const deg = Math.round(degree * 10) / 10;
        const tempInF = Math.round(deg * 10) / 10;
        return tempInF;
      }
    },

    getFilterValue(field) {
      if (
        this.getTableHeaders &&
        this.getTableHeaders.columns &&
        field.dataField == "At"
      ) {
        const atColumn = this.getTableHeaders.columns.find(
          (column) => column.dataField == "At"
        );
        if (
          atColumn &&
          atColumn.filterValue &&
          atColumn.filterValue.length > 0
        ) {
          atColumn.filterValue = atColumn.filterValue.map((val) => {
            return val ? new Date(val) : null;
          });
        }
        return atColumn?.filterValue;
      }
      return (
        this.getTableHeaders &&
        this.getTableHeaders.columns?.find(
          (item) => item.dataField == field.dataField
        ) &&
        this.getTableHeaders.columns.find(
          (item) => item.dataField == field.dataField
        ).filterValue
      );
    },
    getCustomFieldData(data) {
      // console.log('getCustomFieldData', data);
      const customFieldId = data.column.dataField.split(".")[1];
      const customFieldType = data.data.customField_type[customFieldId];
      // console.log('customFieldType', customFieldType);
      return {
        type: customFieldType,
        metadata: data.data.customField_metadata[customFieldId],
      };
    },

    async customLoad() {
      if (this.userEmail !== "lt_techteam@visipoint.com") {
        await this.onTableHeader({
          url: "/reporting/history",
          // headers: reportHistoryColumns,
        });
        let value = this.getTableHeaders;

        // localStorage.getItem("dashboardGrid");

        if (value) {
          // value = JSON.parse(value);
          // value.searchText = '';
          value.pageIndex = 0;
          value.pageSize = 50;
          // for (let i = 0; i < value.columns.length; i++) {
          //   value.columns[i].filterValue = null;
          //   value.columns[i].filterValues = null;
          //   value.columns[i].sortOrder = null;
        }
        // }
        this.loaded = true;
        return value;
      }
      this.loaded = true;
    },

    customSave(gridState) {
      if (this.userEmail !== "lt_techteam@visipoint.com") {
        gridState.pageIndex = 0;
        gridState.pageSize = 50;

        let value = JSON.stringify(gridState);
        value = value.replace(',"selectedRowKeys":[]', "");
        // localStorage.setItem('dashboardGrid', value);
        console.log(
          "customsave",
          value == JSON.stringify(this.getTableHeaders)
        );

        if (this.loaded && !this.getTableHeaders) {
          this.createTableHeaders({
            url: "/reporting/history",
            headers: value,
            filters: "[]",
          });
        } else if (
          this.loaded &&
          value != JSON.stringify(this.getTableHeaders)
        ) {
          this.updateTableHeaders({
            url: "/reporting/history",
            headers: value,
            filters: "[]",
          });
        }
      }
    },

    serverSideExport(e) {
      this.exportJobBE({
        type: e.itemData,
        // headers: columns.reduce((accumulator, value) => {
        //   return { ...accumulator, [value]: value };
        // }, {}),
        gridName: "History",
        entity_id: this.currentEntity.id,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        // filterBy: this.finalFilterObject,
        // orderBy: this.sortObject,
      });
    },

    trimText(data, showingFullText) {
      if (showingFullText) {
        return data;
      }
      return data && data !== "-" && data.length > 37
        ? `${data.slice(0, 37).trim()}...`
        : data;
    },

    changeFullText(data) {
      // console.log(data);
      // data.showingFullText = !data.showingFullText;
      // this.dataGrid
      //   .getDataSource()
      //   ._items.map((item) => item.showingFullText = true);
      const newNotes = this.trimText(
        data.originalVisitNotes,
        !data.showingFullText
      );

      data.Notes = newNotes;
      data.showingFullText = !data.showingFullText;
      this.dataGrid.refresh("changesOnly");
    },

    setUserData(data) {
      this.setData({
        type: "report_document",
        data,
      });
    },
    renderVaccineDocumentColor(type) {
      switch (type) {
        case "Vaccinated":
          return "text-primary font-weight-bold";
        case "Not Applicable":
          return "text-secondary";
        case "Expired":
          return "text-warning font-weight-bold";
        case "Negative PCR":
          return "text-success font-weight-bold";
        default:
          return "";
      }
    },
    isNotEmpty(value) {
      return value !== undefined && value !== null && value !== "";
    },
    clearFilter() {
      this.dataGrid.clearFilter("row");
      this.dataGrid.clearFilter("header");
      this.dataGrid.clearSorting();
      this.showClearAll = false;
    },
    contentReady(e) {
      let sortedExp = this.getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      this.setColumnChooserPosition();
    },
    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.dataGrid.columnCount()).keys()
      ).map((index) => this.dataGrid.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },
    onEditorPreparing(e) {
      if (e.parentType === 'filterRow' && e.editorName === 'dxTextBox' && e.dataField && !e.dataField.includes("customFields.") && e.dataField !== "temperature") {
        const originalOnValueChanged = e.editorOptions.onValueChanged;

        e.editorOptions.onValueChanged = debounce((args) => {
          const value = args.value;

          // Only apply filter if 3 or more characters
          if (value && value.length >= 3) {
            originalOnValueChanged && originalOnValueChanged(args);
          } else if (value === '' || value == null) {
            // Allow clearing the filter
            originalOnValueChanged && originalOnValueChanged(args);
          } else {
            // Prevent filtering if less than 3 characters
            e.component.columnOption(e.dataField, 'filterValue', null);
          }
        }, 400); // debounce delay (ms)
      }
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
    },
    calculateActionBy(rowData) {
      let actionBy = rowData.By;
      try {
        const type = actionBy.type;
        if (type == "Admin" || type == "admin")
          return type + " - " + actionBy.fullName;
        else return type ? type : "-";
      } catch (e) {
        return "-";
      }
    },
    setColumnChooserPosition() {
      // this.dataGrid.showColumnChooser();

      var columnChooserView = this.dataGrid.getView("columnChooserView");

      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }

      columnChooserView._popupContainer.option("position", {
        of: this.dataGrid.element(),
        my: this.getLanguage === "en" ? "left top" : "right top",
        at: this.getLanguage === "en" ? "left top" : "right top",
        offset: "0 50",
      });
    },
    changeTemperature() {

      const dataSource = this.dataGrid.getDataSource();
      const store = dataSource.store();

      const updatedItems = dataSource.items().map((row) => {
          if (row.temperature !== "-") 
              return { ...row, temperature: this.getRowTemp(row) }; 
          return row;
      });

      updatedItems.forEach((item) => store.push([{ type: "update", key: item.id, data: item }]));
      dataSource.reload();
    },
    setSmileysColor(scaleCount) {
      let smileyColors = [];
      switch (scaleCount) {
        case 2:
          smileyColors = ["rgb(230, 10, 62)", "rgb(25, 179, 148)"];
          break;
        case 3:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(255, 152, 20)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 4:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(246, 104, 34)",
            "rgb(178, 161, 62)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 5:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(242, 81, 41)",
            "rgb(255, 152, 20)",
            "rgb(140, 165, 84)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 6:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(240, 66, 45)",
            "rgb(250, 123, 28)",
            "rgb(209, 157, 45)",
            "rgb(117, 168, 96)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 7:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(238, 57, 48)",
            "rgb(246, 104, 34)",
            "rgb(255, 152, 20)",
            "rgb(178, 161, 62)",
            "rgb(101, 170, 105)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 8:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(237, 50, 50)",
            "rgb(244, 91, 38)",
            "rgb(251, 131, 26)",
            "rgb(222, 155, 38)",
            "rgb(156, 163, 74)",
            "rgb(90, 171, 111)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 9:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(236, 45, 51)",
            "rgb(242, 81, 41)",
            "rgb(248, 116, 30)",
            "rgb(255, 152, 20)",
            "rgb(197, 158, 52)",
            "rgb(140, 165, 84)",
            "rgb(82, 172, 116)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 10:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(235, 41, 52)",
            "rgb(241, 73, 43)",
            "rgb(246, 104, 34)",
            "rgb(252, 136, 24)",
            "rgb(229, 155, 34)",
            "rgb(178, 161, 62)",
            "rgb(127, 167, 91)",
            "rgb(76, 173, 119)",
            "rgb(25, 179, 148)",
          ];
          break;
      }

      return smileyColors;
    },
    setSmileysText(scaleCount) {
      let smileyText = [];
      switch (scaleCount) {
        case 3:
        smileyText = [this.$t('customFields.smileys.poor'), this.$t('customFields.smileys.ok'), this.$t('customFields.smileys.good')];
          break;
        case 5:
        smileyText = [this.$t('customFields.smileys.bad'), this.$t('customFields.smileys.poor'), this.$t('customFields.smileys.ok'), this.$t('customFields.smileys.good'), this.$t('customFields.smileys.great')];
          break;
      }
      return smileyText;
    },
    getRatingScaleData(data) {
      const customField = this.allCustomFields.find(
        (field) => field.id == data.column.dataField.split(".")[1]
      );
      const smileyColors = this.setSmileysColor(
        customField.metadata[0].scale_count
      );
      const smileyText = this.setSmileysText(
        customField.metadata[0].scale_count
      );
      const visibleSmiley =
        this.smileysToShow[customField.metadata[0].scale_count - 2];
      return {
        smileySvg: smileysJson[visibleSmiley[+data.value - 1] + "Colored"],
        smileyColor: smileyColors[+data.value - 1],
        smileyText: smileyText[+data.value - 1],
      };
    },
    getCheckboxVal(data) {
      const parsedArray = JSON.parse(data);
      if (Array.isArray(parsedArray)) {
        return parsedArray.join(" - ");
      } else {
        return "-";
      }
    },
    onDataErrorOccurred(e) {
      console.log("onDataErrorOccurred e", e);
      setTimeout(() => {
        let errorRow = document.querySelector(
          ".dx-datagrid-headers .dx-error-message"
        );
        errorRow.innerHTML = this.$t("common.notes.anErrorOccurredGrid");
      }, 100);
    },
    async renderHistoryGridData() {
      this.dataStore = await new CustomStore({
        key: ["ScanId"],
        load: async (loadOptions) => {
          this.gridEmptyMessage = await this.$t('common.grid.loadingData');
          let params = "?";
          let filterQuery = "";
          let sortObject = { sortField: null, sortOrder: "" };
          [
            "skip",
            "take",
            "requireTotalCount",
            "requireGroupCount",
            "sort",
            "filter",
            "totalSummary",
            "group",
            "groupSummary",
          ].forEach((i) => {
            if (i in loadOptions && this.isNotEmpty(loadOptions[i])) {
              params += `${i}=${JSON.stringify(loadOptions[i])}&`;
              if (i == "filter")
                filterQuery += `${JSON.stringify(loadOptions[i])}`;
              if (i == "sort") {
                sortObject.sortField = loadOptions[i][0].selector;
                sortObject.sortOrder = loadOptions[i][0].desc ? "desc" : "asc";
              }
            }
          });
          // this.resetHistoryData();
          params = params.slice(0, -1);
          let filters;
          let finalFilterObject = {};
          this.multipleFilters = [];
          if (filterQuery) filters = JSON.parse(filterQuery);
          if (filters) console.log("filters", filters);
          if (filters && typeof filters[0] === "string") {
            if (filters[0] == "!") {
              console.log("not");
              if (typeof filters[1] === "object") {
                const excludeIds = [];
                const columnHeader =
                  typeof filters[1][0] === "object"
                    ? filters[1][0][0] + "HeaderFilter"
                    : filters[1][0] + "HeaderFilter";
                const columnHeaderFilter =
                  columnHeader.charAt(0).toLowerCase() + columnHeader.slice(1);
                console.log(columnHeader); // name of column filter
                if (typeof filters[1][0] === "object") {
                  console.log("obj");
                  filters[1].map((item) => {
                    if (typeof item === "object") {
                      console.log("item", item[2][0]);
                      excludeIds.push(item[2][0]);
                    }
                  });
                } else {
                  console.log("else");
                  // filters[1].map(item => {
                  // if (typeof item === "object") {
                  console.log("item", filters[1][2][0]);
                  excludeIds.push(filters[1][2][0]);
                  // }
                  // });
                }
                console.log(this[columnHeaderFilter]);
                const arr = this[columnHeaderFilter].filter(
                  (el) => !excludeIds.includes(el.value[2][0])
                );
                console.log("arr", arr, excludeIds);
                if (typeof filters[1][0] === "object") {
                  finalFilterObject[filters[1][0][0]] = arr.map((item) => {
                    return item.value[2][0];
                  });
                } else {
                  finalFilterObject[filters[1][0]] = arr.map((item) => {
                    return item.value[2][0];
                  });
                }
                console.log("finalFilterObject", finalFilterObject);
                if (this.multipleFilters.length > 0) {
                  this.multipleFilters.push(finalFilterObject);
                }
              }
            } else {
              if (
                (filters[1] === "contains" || filters[1] === "=") &&
                this.allFilterHeaders.includes(filters[0])
              )
                filters[2] = [filters[2]]; // make it array;
              finalFilterObject[filters[0]] =
                filters[1] === "contains" || filters[1] === "="
                  ? filters[2]
                  : filters[2];
            }
            if (this.multipleFilters.length > 0) {
              this.multipleFilters.push(finalFilterObject);
            }
          } else {
            // const isOr = filters[1] === 'or';
            // const isAnd = filters[1] === 'and';
            if (filters)
              for (const filter of filters) {
                // console.log('filter', filter);
                // not filter
                if (filter[0] == "!") {
                  // console.log('multiple filters not');
                  if (typeof filter[1] === "object") {
                    const excludeIds = [];
                    const columnHeader =
                      typeof filter[1][0] === "object"
                        ? filter[1][0][0] + "HeaderFilter"
                        : filter[1][0] + "HeaderFilter";
                    const columnHeaderFilter =
                      columnHeader.charAt(0).toLowerCase() +
                      columnHeader.slice(1);
                    // console.log(columnHeader); // name of column filter
                    if (typeof filter[1][0] === "object") {
                      // console.log('obj');
                      filter[1].map((item) => {
                        if (typeof item === "object") {
                          // console.log('item', item[2][0]);
                          excludeIds.push(item[2][0]);
                        }
                      });
                    } else {
                      // console.log('else');
                      // filters[1].map(item => {
                      // if (typeof item === "object") {
                      // console.log('item', filter[1][2][0]);
                      excludeIds.push(filter[1][2][0]);
                      // }
                      // });
                    }
                    // console.log(this[columnHeaderFilter]);
                    const arr = this[columnHeaderFilter].filter(
                      (el) => !excludeIds.includes(el.value[2][0])
                    );
                    // console.log('arr', arr, excludeIds);
                    if (typeof filter[1][0] === "object") {
                      finalFilterObject[filter[1][0][0]] = arr.map((item) => {
                        return item.value[2][0];
                      });
                    } else {
                      finalFilterObject[filter[1][0]] = arr.map((item) => {
                        return item.value[2][0];
                      });
                    }
                    // console.log('finalFilterObject', finalFilterObject);
                    if (this.multipleFilters.length > 0) {
                      this.multipleFilters.push(finalFilterObject);
                    }
                  }
                }
                let orExist;
                let andExist;
                if (typeof filter === "object") {
                  // console.log('obj', filter);
                  orExist = filter.find((item) => item === "or");
                  andExist = filter.find((item) => item === "and");
                  if (filter[1] == "or") {
                    // Header Filter - Gather In One Condition
                    if (
                      filter[0][1] === ">=" ||
                      filter[0][1] === "<=" ||
                      filter[0][1] === "<"
                    ) {
                      const finalFilter = {};
                      const condition = [];
                      for (const filterItem of filter) {
                        if (filterItem[2]) condition.push(filterItem[2][0]);
                      }
                      finalFilter[filter[0][0]] = {
                        start: condition[0].replace(/\//g, "-"),
                        end: condition[1].replace(/\//g, "-"),
                      };
                      finalFilter[filter[0][0]].start = moment
                        .utc(new Date(finalFilter[filter[0][0]].start))
                        .tz("UTC")
                        .format("YYYY-MM-DD HH:mm:ss");
                      finalFilter[filter[0][0]].end = moment
                        .utc(new Date(finalFilter[filter[0][0]].end))
                        .tz("UTC")
                        .format("YYYY-MM-DD HH:mm:ss");
                      this.multipleFilters.push(finalFilter);
                    } else {
                      // Gather In One Condition
                      for (const filter of filter) {
                        if (filter[1] === "contains" || filter[1] === "=") {
                          if (this.allFilterHeaders.includes(filter[0]))
                            filter[2] = [filter[2]]; // make it array;
                          const finalFilter = {};
                          finalFilter[filter[0]] =
                            filter[1] === "contains" || filter[1] === "="
                              ? filter[2]
                              : filter[2];

                          // Header Filter - Gather In One Condition
                          const filterExist = this.multipleFilters.find(
                            (item) => item[filter[0]]
                          );
                          if (!filterExist)
                            this.multipleFilters.push(finalFilter);
                          else filterExist[filter[0]].push(filter[2][0]);
                        }
                      }
                    }
                  } // -------------- Header Filter --------------------
                  if (filter[1] == "and" && filter[0][1] == ">=") {
                    // Range Condition
                    const finalFilter = {};
                    const condition = [];
                    //"Arrival":{"start":"2022-03-10 00:00:00","end":"2022-03-12 23:59:59"}
                    for (const filterItem of filter) {
                      if (typeof filterItem === "object" && filterItem[2])
                        condition.push(filterItem[2]);
                    }
                    finalFilter[filter[0][0]] = {
                      start: condition[0].replace(/\//g, "-"),
                      end: condition[1].replace(/\//g, "-"),
                    };
                    finalFilter[filter[0][0]].start = moment
                      .utc(new Date(finalFilter[filter[0][0]].start))
                      .tz("UTC")
                      .format("YYYY-MM-DD HH:mm:ss");
                    finalFilter[filter[0][0]].end = moment
                      .utc(new Date(finalFilter[filter[0][0]].end))
                      .tz("UTC")
                      .format("YYYY-MM-DD HH:mm:ss");
                    this.multipleFilters.push(finalFilter);
                  } // -------------- Range Condition --------------------
                }
                if (
                  filter.length > 0 &&
                  filter[0] &&
                  filter[0] !== "Actions" &&
                  !orExist &&
                  !andExist
                ) {
                  if (filter[1] === "contains" || filter[1] === "=") {
                    if (this.allFilterHeaders.includes(filter[0]))
                      filter[2] = [filter[2]]; // make it array;
                    const finalFilter = {};
                    finalFilter[filter[0]] =
                      filter[1] === "contains" || filter[1] === "="
                        ? filter[2]
                        : filter[2];

                    // Header Filter - Gather In One Condition
                    const filterExist = this.multipleFilters.find(
                      (item) => item[filter[0]]
                    );
                    if (!filterExist) this.multipleFilters.push(finalFilter);
                    else filterExist[filter[0]].push(filter[2][0]);
                  }
                  if (
                    filter[1] === ">=" ||
                    filter[1] === "<=" ||
                    filter[1] === "<"
                  ) {
                    const finalFilter = {};
                    const filter2 =
                      typeof filter[2] !== "number" && filter[2].includes("/")
                        ? filter[2].replace(/\//g, "-")
                        : filter[2];
                    finalFilter[filter[0]] = { start: "", end: "" };
                    // Range Condition
                    const filterExist = this.multipleFilters.find(
                      (item) => item[filter[0]]
                    );
                    if (!filterExist) {
                      // finalFilter[filter[0]].start = filter2;
                      finalFilter[filter[0]].start = moment
                        .utc(new Date(filter2))
                        .tz("UTC")
                        .format("YYYY-MM-DD HH:mm:ss");
                      finalFilter[filter[0]].end = moment
                        .utc(new Date(filter2))
                        .tz("UTC")
                        .format("YYYY-MM-DD HH:mm:ss");
                      this.multipleFilters.push(finalFilter);
                    } else
                      filterExist[filter[0]].end = moment
                        .utc(new Date(filter2))
                        .tz("UTC")
                        .format("YYYY-MM-DD HH:mm:ss");
                  }
                } else if (andExist) {
                  for (const andFilter of filter) {
                    if (
                      andFilter.length > 0 &&
                      andFilter[0] &&
                      andFilter[0] !== "Actions"
                    ) {
                      if (andFilter[1] === "contains" || andFilter[1] === "=") {
                        if (this.allFilterHeaders.includes(andFilter[0]))
                          andFilter[2] = [andFilter[2]]; // make it array;
                        const finalFilter = {};
                        finalFilter[andFilter[0]] =
                          andFilter[1] === "contains" || andFilter[1] === "="
                            ? andFilter[2]
                            : andFilter[2];
                        this.multipleFilters.push(finalFilter);
                      }
                      if (andFilter[1] === "and" && andFilter[0][1] == ">=") {
                        // range condition
                        const finalFilter = {};
                        const condition = [];
                        for (const filterItem of andFilter) {
                          const filterItem2 =
                            typeof filterItem[2] !== "number" &&
                            filterItem[2].includes("/")
                              ? filterItem[2].replace(/\//g, "-")
                              : filterItem[2];
                          if (typeof filterItem === "object" && filterItem[2])
                            condition.push(filterItem2);
                        }
                        finalFilter[andFilter[0][0]] = {
                          start: condition[0].replace(/\//g, "-"),
                          end: condition[1].replace(/\//g, "-"),
                        };
                        finalFilter[andFilter[0][0]].start = moment
                          .utc(new Date(finalFilter[andFilter[0][0]].start))
                          .tz("UTC")
                          .format("YYYY-MM-DD HH:mm:ss");
                        finalFilter[andFilter[0][0]].end = moment
                          .utc(new Date(finalFilter[andFilter[0][0]].end))
                          .tz("UTC")
                          .format("YYYY-MM-DD HH:mm:ss");
                        this.multipleFilters.push(finalFilter);
                      }
                    }
                  }
                }
              }
          }
          finalFilterObject =
            this.multipleFilters && this.multipleFilters.length > 0
              ? Object.assign({}, ...this.multipleFilters)
              : finalFilterObject;
          // console.log(
          //   "fffff",
          //   finalFilterObject,
          //   JSON.stringify(finalFilterObject)
          // );

          // Extract entries and filter only those with keys starting with "customFields."
          const customFieldsEntries = Object.entries(finalFilterObject).filter(
            ([key]) => key.startsWith("customFields.")
          );

          // Map the filtered entries to the new structure
          const customFieldsArray = customFieldsEntries.map(([key, value]) => {
            const customFieldId = key.split(".")[1]; // Extract the customFieldId part
            return {
              customFieldId,
              value,
            };
          });

          // Return the new structure
          const customFieldsFilter = {
            customFields: customFieldsArray,
          };

          for (var prop in finalFilterObject) {
            if (typeof finalFilterObject[prop] === "string") {
              finalFilterObject[prop] = finalFilterObject[prop].trim();
            }
          }

          let queryParams = {
            filterBy: finalFilterObject,
            customFieldsFilter,
            orderBy: sortObject ? sortObject : { sortField: null },
          };

          if (this.isExport) {
            queryParams.isExporting = true;
          }
          return await Api()
            .get(
              `/report_list_history/${store.getters["authfack/currentEntity"].id}${params}`,
              {
                params: queryParams,
              }
            )
            .then((data) => {
              const reportData = [];
              let entity = store.getters["authfack/currentEntity"];
              data.data.scans.map((report) => {
                // console.log(report);
                let userTimezone = moment.tz.guess();
                let degree =
                  this.selectedTempreture == "c"
                    ? report.temperature
                    : report.temperature * (9 / 5) + 32;
                reportData.push({
                  location: report.location,
                  entity_id: report.entity_id,
                  visit_id: report.visit_id,
                  user_id: report.user_id,
                  ScanId: report.id,
                  Image: report.image
                    ? report.image_base64
                      ? report.image_base64
                      : report.image
                    : null, // base64Img
                  Label: report.labels,
                  Action: report.scanDataTypeName ?? "",
                  scanDateTypeId: report.scanDateTypeId ?? "",
                  scan_data_type: report.scan_data_type
                    ? report.scan_data_type
                    : "",
                  failed_message: report.failed_message,
                  FirstName: report.first_name ?? "-",
                  LastName: report.last_name ?? "-",
                  Email:
                    !this.checkIfUserIsDeleted(report.entity_user_id) &&
                    report.email
                      ? report.email
                      : "-",
                  PhoneNumber:
                    !this.checkIfUserIsDeleted(report.entity_user_id) &&
                    report.phone
                      ? report.phone
                      : "-",
                  companyName:
                    !this.checkIfUserIsDeleted(report.entity_user_id) &&
                    report.company_name
                      ? report.company_name
                      : "-",
                  vehicleRegistration:
                    !this.checkIfUserIsDeleted(report.entity_user_id) &&
                    report.vehicle_registration
                      ? report.vehicle_registration
                      : "-",
                  By: report.action_by ?? "-",
                  UserType: report.userTypeName ?? "-",
                  ID:
                    !this.checkIfUserIsDeleted(report.entity_user_id) &&
                    report.user_user_id
                      ? report.user_user_id
                      : null,
                  attendanceCode:
                    report.scanDateTypeId != 5 || report.scanDateTypeId != 8
                      ? report.attendance_code ?? "-"
                      : "-",
                  Reason:
                    report.scanDateTypeId != 5 || report.scanDateTypeId != 8
                      ? report.reason_name &&
                        report.action_by &&
                        report.action_by.reasonPresentName
                        ? `${report.reason_name} (${report.action_by.reasonPresentName})`
                        : report.reason_name
                        ? report.reason_name
                        : "-"
                      : "-",
                  RFID:
                    !this.checkIfUserIsDeleted(report.entity_user_id) &&
                    report.entity_user?.rf_ids?.length &&
                    report.scanDateTypeId != 5 &&
                    report.scanDateTypeId != 8
                      ? report.entity_user?.rf_ids
                      : "-",
                  Device:
                    report.scanDateTypeId != 8 ? report.deviceName ?? "-" : "-",
                  Notes:
                    report.scanDateTypeId != 5 && report.scanDateTypeId != 8
                      ? report.notes
                        ? this.trimText(report.notes, false)
                        : "-"
                      : "-",
                  originalVisitNotes:
                    report.scanDateTypeId != 5 && report.scanDateTypeId != 8
                      ? report.notes ?? "-"
                      : "-",
                  showingFullText: false,
                  Area: report.areaName ?? "",
                  // report.scanDateTypeId != 5 || report.scanDateTypeId != 8 ?
                  Host:
                    report.host_name && report.host_name.includes("Deleted")
                      ? "Deleted User"
                      : report.host_name && report.host_userType
                      ? `${report.host_name} (${report.host_userType})`
                      : "-", // : "-",
                  // ? report.user_host.fullName + ' (' + report.user_host.current_entity.user_type.name + ')'
                  // : "-",
                  Site: report.siteName ?? "",
                  // don't show if visit status is expected(6), no show(7), added as expected(11),
                  Input:
                    // approved(14), or rejected(15)
                    (report.scanDateTypeId == 6 &&
                      report.journey_stage != "waiting_for_admin_approval") ||
                    report.scanDateTypeId == 7 ||
                    report.scanDateTypeId == 11 ||
                    report.scanDateTypeId == 14 ||
                    report.scanDateTypeId == 8 ||
                    report.scanDateTypeId == 15
                      ? "-"
                      : report.scan_by
                      ? (report.inputMethodsId == 6
                          ? "Kiosk touchscreen"
                          : report.inputMethodsName) +
                        " - " +
                        report.scan_by
                      : report.inputMethodsId == 6
                      ? "Kiosk touchscreen"
                      : report.inputMethodsName, // touch mode(id=6)
                  // don't show if visit status is expected(6), no show(7), added as expected(11),
                  hasAMask:
                    // comp filled in(13), approved(14), or rejected(15)
                    // (report.scanDateTypeId == 6 &&
                    //   report.journey_stage != "waiting_for_admin_approval") ||
                    // report.scanDateTypeId == 7 ||
                    // report.scanDateTypeId == 11 ||
                    // report.scanDateTypeId == 13 ||
                    // report.scanDateTypeId == 18 || // compliance re-sent
                    // report.scanDateTypeId == 14 ||
                    // report.scanDateTypeId == 8 ||
                    // (report.scanDateTypeId == 5 &&
                    //   report.user_id.includes("undefined")) ||
                    // report.scanDateTypeId == 15
                    //   ? "-" :
                      report.has_mask == 1
                      ? "Yes"
                      : report.has_mask == 0
                      ? "No"
                      : "-",
                  Compliances:
                    report.scanDateTypeId == 5 && report.haveDetails
                      ? "expected"
                      : report.scanDateTypeId == 5 || // undefined user
                        report.scanDateTypeId == 8 || // signed out
                        report.scanDateTypeId == 4 || // auto signed out
                        report.scanDateTypeId == 13 || // comp filled in
                        report.scanDateTypeId == 10 || // visit updated
                        report.scanDateTypeId == 11 // added as expected
                      ? "-"
                      : report.haveDetails
                      ? report.scanDateTypeId == 6 || // expected
                        report.scanDateTypeId == 15 || // rejected
                        report.scanDateTypeId == 7 || // no show
                        report.scanDateTypeId == 12 // visit deleted
                        ? "expected"
                        : report.compliances
                      : report.compliances,
                  // don't show if visit status is expected(6), no show(7), added as expected(11),
                  temperature:
                    // comp filled in(13), approved(14), or rejected(15)
                    (report.scanDateTypeId == 6 &&
                      report.journey_stage != "waiting_for_admin_approval") ||
                    report.scanDateTypeId == 7 ||
                    report.scanDateTypeId == 11 ||
                    report.scanDateTypeId == 13 ||
                    report.scanDateTypeId == 14 ||
                    report.scanDateTypeId == 8 ||
                    (report.scanDateTypeId == 5 &&
                      report.user_id.includes("undefined")) ||
                    report.scanDateTypeId == 15 ||
                    !degree ||
                    !report.temperature
                      ? "-"
                      : this.getRowTemp(report) +" °"+
                        (this.selectedTempreture == "f" ? this.$t('common.temperatureUnits.f') : this.$t('common.temperatureUnits.c')),
                  failedKey: report.failed_key,
                  At: report.scan_time
                    ? moment.utc(report.scan_time).tz(userTimezone)
                    : "-",
                  scan_time: report.scan_time,
                  unit: report.temperature_type
                    ? report.temperature_type
                    : entity.setting[0].pivot.value,
                  deg: Math.round(degree * 10) / 10,
                  defaultUnit: " °"+report.temperature_type
                    ? report.temperature_type == "f"
                      ?  this.$t('common.temperatureUnits.f')
                      : this.$t('common.temperatureUnits.c')
                    : entity.setting[0].pivot.value == "f"
                    ? this.$t('common.temperatureUnits.f')
                    : this.$t('common.temperatureUnits.c'),
                  defaultUnitType: report.temperature_type
                    ? report.temperature_type
                    : entity.setting[0].pivot.value,
                  VaccineDocument:
                    report.scanDateTypeId == 5 ||
                    report.scanDateTypeId == 8 ||
                    report.scanDateTypeId == 9 || // auto signed in
                    report.scanDateTypeId == 4 ||
                    report.scanDateTypeId == 13 || // comp filled in
                    report.scanDateTypeId == 10 || // visit updated
                    report.scanDateTypeId == 11 // added as expected
                      ? "-"
                      : report.haveDocument
                      ? report.userDocument.length > 0 &&
                        report.userDocument[0].pivot &&
                        report.userDocument[0].pivot.metadata.document_status
                        ? report.userDocument[0].pivot.metadata.document_status
                        : report.metadata &&
                          report.metadata.checks &&
                          report.metadata.checks.length > 0 &&
                          report.metadata.checks[0].type == "vaccine_document"
                        ? "Unchecked"
                        : "Not Applicable"
                      : "-",
                  LastVaccine: report.userDocument[0],
                  JourneyStage:
                    report.scanDateTypeId != 5 || report.scanDateTypeId != 8
                      ? report.journey_stage_text
                      : "-",
                  customFields: report.customFields,
                  customField_type: report.customField_type,
                  customField_metadata: report.customField_metadata,
                });
              });
              this.isServerSideExport =
                data.data.totalCount >= process.env.VUE_APP_EXPORT_LIST_COUNT;
              this.finalFilterObject = finalFilterObject;
              this.sortObject = sortObject ? sortObject : { sortField: null };
              this.totalCount = data.data.totalCount;
              // this.resetHistoryData();
              this.dataGrid.endCustomLoading();
              this.gridEmptyMessage = this.$t('common.grid.noRecordsYet');
              return {
                data: reportData,
                totalCount: data.data.totalCount,
                summary: data.data.summary,
                groupCount: data.data.groupCount,
              };
            })
            .catch((err) => {
              throw new Error(err);
            });
        },
      });
    },
  },
  created() {
    document.addEventListener("mousedown", (e) => {
      if (e.path) {
        let isColumnChooser = false;
        for (let i = 0; i < e.path.length; i++) {
          if (typeof e.path[i].matches == "function") {
            if (e.path[i].matches(".dx-overlay-content")) {
              isColumnChooser = true;
            }
          }
        }
        if (!isColumnChooser) this.dataGrid.hideColumnChooser();
      }
    });
  },
  async mounted() {
    this.dataGrid.beginCustomLoading();
    window.addEventListener("unload", this.resetFilterValues());
  },
  destroyed() {
    this.resetFilterValues();
  },
  async beforeMount() {

    if (this.getLanguage == "ar") {
      this.rtlEnabled = true;
    }

    await this.fetchHistoryData().then((res) => {
      this.historyData = res.data;
      // console.log("this.historyData", this.historyData);

      this.historyData.sites?.forEach((site) => {
        this.siteHeaderFilter.push({
          text: site.name,
          value: site.id,
        });
      });

      this.vaccineDocument = this.historyData.documentTypes.documents;
      this.getCompliances = this.historyData.compliances ? this.historyData.compliances : [];

      this.historyData.areas?.forEach((area) => {
        this.areaHeaderFilter.push({
          text: area.name,
          value: area.id,
        });
      });

      this.historyData.devices?.forEach((device) => {
        this.deviceHeaderFilter.push({
          text: device.name,
          value: device.id,
        });
      });

      this.allLabels = this.historyData.labels;
      this.getVaccinePCRColumnAppearance = this.historyData.dashboardColumns;

      this.historyData.userTypesOneLevel?.map((userType) => {
        this.userTypeHeaderFilter.push({
          text: userType.name,
          value: userType.id,
        });
      });

      this.allCustomFields = this.historyData.customFields ? this.historyData.customFields : [];
        this.allCustomFields.forEach((field) => {
          if (field.type == "ratingScale" || field.type == "toggleButton") {
            this.allFilterHeaders.push(`customFields.${field.id}`);
          }
      });

      this.historyData.scanDataTypes?.map((status) => {
        this.statusHeaderFilter.push({
          text: status.name,
          value: status.id,
        });
      });

      this.historyData.inputMethods?.map((inputType) => {
        
        this.inputTypeHeaderFilter.push({
          text: inputType.name,
          value: inputType.id,
        });
      });
    });

    const { currentEntity } = this;
    if (currentEntity.setting && currentEntity.setting.length > 0) {
      currentEntity.setting.forEach((row) => {
        if (row.name == "temperature_display_unit_for_company") {
          this.selectedTempreture = row.pivot ? row.pivot.value : "c";
        }
      });
    }
    await this.renderHistoryGridData();
  },
};
</script>

<template>
  <div class="main-page-container">
    <!-- exporting -->
    <b-modal
      id="exportingProgress"
      hide-footer
      hide-header
      size="lg"
      :scrollable="false"
    >
      <ExportProgress />
    </b-modal>
    <AlertFoundActiveSession />
    <!-- vaccine details  -->
    <PageHeader :title="$t('sideNavbarMenu.reporting.list.History')" />
    <b-modal
      id="vaccineDetailsModal"
      class="popover-modal"
      hide-header
      hide-footer
      no-close-on-esc
      :scrollable="true"
      ref="vaccineDetailsModal"
    >
      <VaccineDetails />
    </b-modal>
    <!-- grid -->
    <section class="history-white-bg-sec">
      <DxDataGrid
        :data-source="dataStore"
        id="gridContainer"
        :ref="dataGridRefName"
        :no-data-text="gridEmptyMessage"
        :remote-operations="true"
        :showBorders="false"
        :columnAutoWidth="true"
        :allowColumnReordering="true"
        :allowColumnResizing="false"
        :rowAlternationEnabled="false"
        :showColumnLines="true"
        :showRowLines="true"
        :repaint-changes-only="true"
        :two-way-binding-enabled="true"
        :class="{
          historyGridHeightWithAlert: getActiveSessionsCount,
          historyGridHeight: !getActiveSessionsCount,
        }"
        @content-ready="contentReady($event)"
        @editor-preparing="onEditorPreparing($event)"
        :columns="gridColumns"
        @data-error-occurred="onDataErrorOccurred($event)"
        :rtl-enabled="rtlEnabled"
      >
        <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />

        <DxStateStoring
          :enabled="true"
          type="custom"
          :customLoad="customLoad"
          :customSave="customSave"
          storage-key="historyGrid"
        />

        <DxPaging :page-size="50" />
        <DxPager
          :visible="true"
          :allowed-page-sizes="[5, 10, 25, 50, 100]"
          :display-mode="'full'"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
          :infoText="rtlEnabled ?  'صفحة {0} من {1} ({2} إجمالي العناصر)' : ''"

        />

        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />

        <DxColumnChooser
          :enabled="true"
          mode="select"
          :title="$t('common.grid.columnChooser')"
        />
        <DxExport :enabled="true" :allow-export-selected-data="false" />

        <DxToolbar>
          <!-- <DxItem name="columnChooserButton" location="before" /> -->
          <DxItem location="before" template="columnButtonTemplate" />
          <DxItem template="exportButtonTemplate" location="before" />
          <DxItem template="clearAllTemplate" location="before" />
          <DxItem template="tempUnitsTemplate" />
        </DxToolbar>

        <template #rfid-template="{ data }">
          {{ data.data.RFID ? rfidFormatter(data.data.RFID) : "-" }}
        </template>

        <template #id-cell="{ data }">
          {{ data.data.ID ? data.data.ID : "-" }}
        </template>

        <template #image-cell="{ data }">
          <div v-viewer class="images dash-img clearfix">
            <ImageCell
              v-if="!data.data.Image"
              :image="data.data.Image"
              :name="data.data.FirstName ? data.data.FirstName.charAt(0) : ''"
            />
            <img
              class="img-fluid rounded-circle"
              v-if="data.data.Image"
              style="cursor: pointer"
              :src="data.data.Image"
            />
          </div>
        </template>
        <template #status-cell="{ data }">
          <div>
            <!-- DENIED & AUTO SIGNED OUT STATUS -->
            <div
              class="d-flex align-items-center"
              v-if="
                data.data.scanDateTypeId == 5 || data.data.scanDateTypeId == 8
              "
            >
              <span class="text-red font-weight-bolder">
                {{ data.data.Action }}
              </span>
              <svg
                tabindex="0"
                v-b-tooltip
                :id="data.data.ScanId"
                style="margin-inline-start: 8px; outline: none"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z"
                  fill="#787878"
                />
              </svg>
                <b-tooltip
                placement="bottomright"
                :target="data.data.ScanId"
                triggers="click blur"
              >
                {{ data.data.failed_message ? data.data.failed_message : "-" }}
              </b-tooltip>
            </div>

            <!-- AUTO SIGNED IN STATUS -->
            <div
              class="d-flex align-items-center"
              v-else-if="
                data.data.scanDateTypeId == 9 ||
                (data.data.scanDateTypeId === '1' && data?.data?.failed_message)
              "
            >
              <span class="text-green font-weight-bolder">
                {{ data.data.Action }}
              </span>
              <svg
                tabindex="0"
                v-b-tooltip
                :id="data.data.ScanId"
                style="margin-inline-start: 8px; outline: none"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z"
                  fill="#787878"
                />
              </svg>
              <b-tooltip
                placement="bottomright"
                :target="data.data.ScanId"
                triggers="click blur"
              >
                {{ data.data.failed_message ? data.data.failed_message : "-" }}
              </b-tooltip>
            </div>

            <!-- SIGNED OUT & VISIT REJECTED STATUS -->
            <div
              class="d-flex align-items-center"
              v-else-if="
                data.data.scanDateTypeId == 4 ||
                data.data.scanDateTypeId == 15 ||
                data.data.scanDateTypeId == 12 ||
                data.data.scanDateTypeId == 17
              "
            >
              <span class="text-red font-weight-bolder">
                {{ data.data.Action }}
              </span>
            </div>

            <!-- VISIT UPDATED STATUS -->
            <div
              class="d-flex align-items-center"
              v-else-if="data.data.scanDateTypeId == 10"
            >
              <span>{{ data.data.Action }}</span>
              <svg
                tabindex="0"
                v-b-tooltip
                :id="data.data.ScanId"
                style="margin-inline-start: 8px; outline: none"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z"
                  fill="#787878"
                />
              </svg>

              <b-tooltip
                placement="bottomright"
                :target="data.data.ScanId"
                triggers="click blur"
              >
                {{ data.data.failed_message ? data.data.failed_message : "-" }}
              </b-tooltip>
            </div>

            <!-- NO SHOW STATUS -->
            <div
              class="d-flex align-items-center"
              v-else-if="data.data.scanDateTypeId == 7"
            >
              <span style="font-weight: 700; font-size: 16px; color: #000000">{{
                data.data.Action
              }}</span>
              <svg
                tabindex="0"
                v-b-tooltip
                :id="data.data.ScanId"
                style="margin-inline-start: 8px; outline: none"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z"
                  fill="#787878"
                />
              </svg>
              <b-tooltip
                placement="bottomright"
                :target="data.data.ScanId"
                triggers="click blur"
              >
                {{ data.data.failed_message ? data.data.failed_message : "-" }}
              </b-tooltip>
            </div>

            <!-- COMPLIANCE FILLED IN STATUS -->
            <div
              class="d-flex align-items-center"
              v-else-if="data.data.scanDateTypeId == 13"
            >
              <span>{{ data.data.Action }}</span>
              <svg
                tabindex="0"
                v-b-tooltip.html
                :id="data.data.ScanId"
                style="margin-inline-start: 8px; outline: none"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z"
                  fill="#787878"
                />
              </svg>
              <b-tooltip
                placement="bottomright"
                :target="data.data.ScanId"
                triggers="click blur"
              >
                <ul style="margin-bottom: unset">
                  <li
                    v-for="(msg, index) in data.data.failed_message"
                    :key="index"
                    class="tool-customization"
                  >
                    {{ msg }}
                    <div
                      v-if="index != data.data.failed_message.length - 1"
                      class="tooltip-separator"
                    ></div>
                  </li>
                </ul>
              </b-tooltip>
            </div>

            <!-- EXPECTED VISIT STATUS -->
            <div
              class="d-flex align-items-center"
              v-else-if="data.data.scanDateTypeId == 6"
            >
              <span class="text-warning font-weight-bolder">{{
                data.data.Action
              }}</span>
            </div>

            <!-- ADDED AS EXPECTED STATUS -->
            <div
              class="d-flex align-items-center"
              v-else-if="data.data.scanDateTypeId == 11"
            >
              <span>{{ data.data.Action }}</span>
            </div>

            <!-- VISIT APPROVED STATUS -->
            <div
              class="d-flex align-items-center"
              v-else-if="data.data.scanDateTypeId == 14"
            >
              <span style="font-weight: 700; font-size: 16px; color: #2680eb">{{
                data.data.Action
              }}</span>
            </div>

            <!-- RE-SENT COMPLIANCE -->
            <div
              v-else-if="data.data.scanDateTypeId == 18"
              class="resent_compliance"
            >
              <span>{{ data.data.Action }}</span>
            </div>

            <!-- SIGNED IN / CHECKED IN STATUS -->
            <div
              v-else
              class="d-flex align-items-center text-green font-weight-bolder"
            >
              {{ data.data.Action }}
            </div>
          </div>
        </template>
        <template #kiosk-cell="{ data }">
          <span class="no-wrap">
            {{ data.data.Device ? data.data.Device : "-" }}
          </span>
        </template>
        <template #temperature-cell="{ data }">
          <div class="float-left">
            <span
              v-if="data.data.temperature == '-'"
              class="dash-normal-color font-weight-bold"
              >{{ data.data.temperature }}</span
            >
            <span
              v-else
              class="font-weight-bolder"
              :class="
                data.data.failedKey == 'high_temperature'
                  ? 'text-red'
                  : 'text-green'
              "
              >{{ data.data.temperature }}</span
            >
          </div>
        </template>
        <template #mask-cell="{ data }">
          <span
            :class="
              data.data.hasAMask == 'Yes'
                ? 'text-green'
                : data.data.hasAMask == 'No'
                ? 'text-red'
                : 'dash-normal-color'
            "
            class="font-weight-bolder"
            >{{ data.data.hasAMask == 'Yes' ? $t("common.yes") : (data.data.hasAMask == 'No' ? $t("common.no") : data.data.hasAMask) }}</span
          >
        </template>
        <template #compliance-cell="{ data }">
          <CompliancesCell
            :data="data.data.Compliances"
            :user_id="data.data.user_id"
            :visit_id="data.data.visit_id"
            :entity_id="data.data.entity_id"
            :scan_id="data.data.ScanId"
            :scan="data.data"
          />
        </template>
        <template #Location-cell="{ data }">
          <span>
            <template v-if="data && data.data && data.data.location">
              <LocationCell :location="data.data.location" />
            </template>
            <template v-else> - </template>
          </span>
        </template>
        <template #document-cell="{ data }">
          <span
            class="text-capitalize"
            @click="
              data.data.VaccineDocument != 'Not Applicable' &&
                setUserData(data.data)
            "
            v-b-modal="
              data.data.VaccineDocument != 'Not Applicable' &&
              'vaccineDetailsModal'
            "
            :class="renderVaccineDocumentColor(data.data.VaccineDocument)"
            >{{ data.data.VaccineDocument }}</span
          >
        </template>
        <template #visit-notes-cell="{ data }">
          <div
            style="
              white-space: normal;
              overflow-wrap: break-word;
              height: 90;
              width: 90;
            "
          >
            {{ data.value }}

            <a
              class="read_more"
              style="cursor: pointer"
              v-if="
                data.data.originalVisitNotes &&
                data.data.originalVisitNotes.length > 37 &&
                data.data.originalVisitNotes !== '-'
              "
              @click="changeFullText(data.data, true)"
            >
            {{ data.data.showingFullText ? $t('common.readLess'): $t('common.readMore') }}
            </a>
          </div>
        </template>
        <template #clearAllTemplate>
          <div v-if="showClearAll" class="clear-cols d-flex align-items-center">
            <div class="toolbar-custom-line"></div>
            <Button
              :text="$t('common.grid.clearFilters')"
              @click="clearFilter"
              styling-mode="outlined"
              type="danger"
              class="clear-CustomColums"
            />
          </div>
        </template>
        <template #exportButtonTemplate>
          <DxDropDownButton
            class="export-dropdown"
            :items="buttonData"
            :text="$t('common.grid.export')"
            @item-click="serverSideExport"
          />

          <!-- <DxDropDownButton
            :items="buttonData"
            text="Export"
            @item-click="onItemClick"
            v-else
          /> -->
        </template>
        <template #columnButtonTemplate>
          <button class="custom-columns" @click="dataGrid.showColumnChooser()">
            <span class="custom-text">{{ $t("common.grid.columns") }} </span>

            <span class="custom-icon">
              <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
            </span>
          </button>
        </template>
        <template #tempUnitsTemplate>
          <div
            class="d-flex align-items-center"
            style="height: 20px; padding-inline-end: 24px"
          >
            <label class="mb-0 custom-temp-unit vp-mr-24" for="radio-slots">{{
              $t("common.temperatureUnit")
            }}</label>
            <div style="height: 20px">
              <v-radio-group
                v-model="selectedTempreture"
                @change="changeTemperature()"
              >
                <v-radio
                  v-for="option in options"
                  :key="option.value"
                  :label="option.text"
                  :value="option.value"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </template>

        <template #customField-template="{ data }">
          <span v-if="!data.value">-</span>

          <span v-else-if="getCustomFieldData(data).type == 'checkboxes'">{{
            getCheckboxVal(data.value)
          }}</span>

          <span v-else-if="getCustomFieldData(data).type == 'toggleButton'">{{
            +data.value ? "Yes" : "No"
          }}</span>

          <template
            v-else-if="
              getCustomFieldData(data).type == 'ratingScale' &&
              getCustomFieldData(data).metadata[0].show_as == 'smileys'
            "
          >
            <div class="d-flex align-items-center" style="gap: 8px">
              <div class="grid-smiley-container">
                <div class="d-flex align-items-center">
                  <span
                    class="svg-div"
                    v-html="getRatingScaleData(data).smileySvg"
                  ></span>
                </div>
              </div>

              <p
                class="smiley-text"
                :style="{ color: getRatingScaleData(data).smileyColor }"
              >
                {{ getRatingScaleData(data).smileyText }}
              </p>
            </div>
          </template>

          <template
            v-else-if="
              getCustomFieldData(data).type == 'ratingScale' &&
              getCustomFieldData(data).metadata[0].show_as == 'stars'
            "
          >
            <div style="position: relative">
              <svg
                width="24"
                height="24"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 25.4465L6.993 29.8547C6.13663 30.3242 5.13656 29.5678 5.29908 28.5701L6.83048 19.2321L0.354854 12.6197C-0.338965 11.9155 0.0423195 10.683 0.998661 10.5395L9.9495 9.17663L13.9561 0.679814C14.3812 -0.226605 15.6188 -0.226605 16.0501 0.679814L20.0505 9.17663L29.0013 10.5395C29.9577 10.683 30.3389 11.9155 29.6452 12.6197L23.1695 19.2321L24.701 28.5701C24.8634 29.5678 23.8634 30.3308 23.007 29.8547L15 25.4465Z"
                  fill="#103F5E"
                />
              </svg>
              <span
                class="rating-star"
                :style="{ marginInlineStart: data.value > 9 ? '-9.5%' : '-8%' }"
                >{{ Number(data.value) }}</span
              >
            </div>
          </template>

          <template
            v-else-if="
              getCustomFieldData(data).type == 'ratingScale' &&
              getCustomFieldData(data).metadata[0].show_as == 'labels'
            "
          >
            <div class="rating-label-container" style="position: relative">
              <span
                class="rating-label"
                :style="{ marginInlineStart: data.value > 9 ? '24%' : '36%' }"
                >{{ Number(data.value) }}</span
              >
            </div>
          </template>

          <span v-else>{{ data.value }}</span>
        </template>
      </DxDataGrid>
    </section>
    <!-- dashboard compliances  -->
    <b-modal
      id="dashboardCompliances"
      hide-footer
      hide-header
      size="md"
      scrollable
    >
      <Compliances />
    </b-modal>
    <!-- dashboard locations  -->
    <b-modal
      id="dashboardLocations"
      hide-footer
      hide-header
      size="lg"
      scrollable
    >
      <Locations />
    </b-modal>
    <!-- action modal -->
    <b-modal
      id="dashboardAction"
      :scrollable="getCompliances.length > 0 ? true : false"
      hide-footer
      hide-header
      size="lg"
    >
      <UserCheckinAction parentGrid="history" />
    </b-modal>
  </div>
</template>
<style lang="scss">
.historyGridHeight .dx-datagrid {
  height: calc(100vh - 197px);
}
.historyGridHeightWithAlert .dx-datagrid {
  height: calc(100vh - 243px);
}

.read_more {
  width: 69px;
  height: 17px;

  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-decoration-line: underline;
  color: #2680eb;
}

.dash-img {
  width: 27px;
  height: 27px;

  & img {
    height: 27px !important;
    width: 27px;
  }
}
.tooltip .tooltip-inner {
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.161);
  color: #787878;
  width: 152px;
}
.tooltip .arrow {
  display: none !important;
}

.tooltip .tooltip-inner:lang(ar){
  position: absolute;
  left: 0px;
}

.tooltip.fade{
  display: none !important;
}

.dx-master-detail-cell {
  background-color: #f3f3f3 !important;
}

.dx-checkbox-checked .dx-checkbox-icon {
  color: #fff;
  background-color: #103f5e;
  border: none;
  font: 16px/1em DXIcons;
  text-align: center;
}
.dx-checkbox-indeterminate .dx-checkbox-icon {
  background-color: #103f5e;
  color: #fff;
  border: none;
  font: 20px/1em DXIcons;
  text-align: center;
}
</style>
<style lang="scss" scoped>
.rating-star {
  position: absolute;
  top: 15%;
  margin: auto;
  color: white;
  font-size: 10px;
}

.rating-label-container {
  background-color: #103f5e;
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.rating-label {
  position: absolute;
  top: 12%;
  margin: auto;
  color: white;
  font-size: 10px;
}

.header-close {
  font-size: 24px !important;
  font-weight: bold !important;
  background-color: transparent;
  border: none;
}

.header-close:active {
  outline: none;
}

h5.modal-title {
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}
.resent_compliance {
  color: #495057;
}
</style>
<style lang="scss">
.history-white-bg-sec {
  .smiley-text {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    margin: auto 0 !important;
  }
  background-color: white;
  padding-inline-start: 0px;
  // padding-top: 25px;
  border-radius: 8px !important;

  td {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    color: #4a4a4a !important;
  }
  .attendanceCodeColumn {
    white-space: break-spaces;
  }
}

[aria-label="Column RFID"] {
  .dx-sort.dx-sort-up,
  .dx-sort.dx-sort-down {
    display: none !important;
  }
}

.grid-smiley-container {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
